// Firestore write promises only settle on server acknowledgment and never
// resolve while offline. Writes apply to the local cache synchronously and
// sync later, so mutations dispatch them detached instead of awaiting.
export const detachWrite = (
  write: Promise<void> | void,
  onWriteError: (error: unknown) => void,
): void => {
  if (!write) {
    return;
  }
  write.catch(onWriteError);
};
